import { render, staticRenderFns } from "./DoQuestion16.vue?vue&type=template&id=3566d603&scoped=true&"
import script from "./DoQuestion16.vue?vue&type=script&lang=js&"
export * from "./DoQuestion16.vue?vue&type=script&lang=js&"
import style0 from "./DoQuestion16.vue?vue&type=style&index=0&id=3566d603&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3566d603",
  null
  
)

component.options.__file = "DoQuestion16.vue"
export default component.exports